export default "__VITE_ASSET__649321ba__"